export default "__VITE_ASSET__958f44bb__"